import React, { useState } from 'react';
import Alert from '~/components/Alert';
import { useTranslation } from 'react-i18next';
import Form from '~/components/WizardForm';
import DocumentInput from '~/components/inputs/DocumentInput';
import ErrorModal, { ErrorModalError } from '~/components/ErrorModal';
import { ImageResponse } from '~/types/files';

export default function NationalAddressCertificate() {
  const { t } = useTranslation('ksaApplication');
  const [error, setError] = useState<ErrorModalError | null>(null);
  return (
    <>
      <Alert
        type="warning"
        showIcon
        message={t('National address lookup failed')}
        description={t('You may upload a National Address Certificate, or continue without it. Our team will review your national address.')}
      />
      <Form.Item
        name={['companyInformation', 'nationalAddressCertificate']}
        labelText={t('National Address Certificate')}
        optional
        getValueFromEvent={(value: ImageResponse | undefined) => value ?? null}
        getValueProps={(value: ImageResponse | null | undefined) => ({ value: value ?? undefined })}
      >
        <DocumentInput
          name="photos"
          multiple={false}
          maxCount={1}
          onUploadError={(uploadError: ErrorModalError) => setError({
            description: uploadError?.description || t('National Address Certificate upload failed', { lng: 'en' }),
            arDescription: uploadError?.arDescription || t('National Address Certificate upload failed', { lng: 'ar' }),
          })}
        />
      </Form.Item>
      <ErrorModal visible={!!error} error={error} onClose={() => setError(null)} />
    </>
  );
}
